module.exports = __webpack_public_path__ + "static/media/ofuroSenpatsu.75484309.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/training_thumbnails/adl/ofuroSenpatsu.png
// module id = 1698
// module chunks = 1